module.exports = __webpack_public_path__ + "static/bg_badge-eacd8231fac5108ad5e97e2cbbc347e8.jpg";